<template>
  <div class="icon-container" @click="openLink" >
    <img class="icon" v-bind:src="require(`../../assets/sidebar/info.svg`)" alt="" color="primary" />
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  setup() {},
  methods: {
    openLink() {
      window.open("https://epicflow.com", "_blank").focus();
    },
  },
});
</script>

<style scoped>
.icon-container {
  width: 100%;
  cursor: pointer;
  height: 60px;
}

.icon {
  width: 32px;
  height: 32px;
  margin-left: calc(50% - 32px / 2);
  margin-top: calc(50% - 32px );
}

.icon-container:hover {
  transition: 0.3s ease;
  background-color: var(--sidebar-item-hover);
}
</style>
